import app from 'flarum/forum/app';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
/**
 * AvatarEditor that shows a crop modal before uploading.
 */
export default class ProfileImageCropAvatarEditor extends AvatarEditor {
  upload(file) {
    if (!file || !window.FileReader) return super.upload(file);
    if (this.loading) return;
    const user = this.attrs.user;
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/ProfileImageCropModal', webpackMode: 'lazy-once' */ './ProfileImageCropModal'), {
      file,
      upload: croppedFile => {
        const data = new FormData();
        data.append('avatar', croppedFile);
        this.loading = true;
        m.redraw();
        return app.request({
          method: 'POST',
          url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(user.id(), "/avatar"),
          serialize: raw => raw,
          body: data
        }).then(response => {
          var _res$data;
          const res = response;
          const attrs = res == null || (_res$data = res.data) == null ? void 0 : _res$data.attributes;
          if (attrs != null && attrs.avatarUrl) {
            attrs.avatarUrl += (attrs.avatarUrl.includes('?') ? '&' : '?') + 't=' + Date.now();
          }
          this.success(response);
          app.modal.close();
        }).catch(error => {
          var _app$modal, _modal$attrs;
          this.failure(error);
          const modal = (_app$modal = app.modal) == null ? void 0 : _app$modal.modal;
          if (modal != null && (_modal$attrs = modal.attrs) != null && _modal$attrs.upload) {
            modal.attrs.error = error;
            m.redraw();
          }
        });
      }
    });
  }
}
flarum.reg.add('fof-profile-image-crop', 'forum/components/ProfileImageCropAvatarEditor', ProfileImageCropAvatarEditor);flarum.reg.addChunkModule('247', '240', 'fof-profile-image-crop', 'forum/components/ProfileImageCropModal');